import { parseBackendDate } from './dates';

// Ventana de servicio al cliente de WhatsApp: 24 h desde el último mensaje del
// cliente. Fuera de ella Graph rechaza el texto libre y solo cabe una plantilla.
// El backend es la barrera (responde 409 con este mismo texto); esto solo
// evita que el agente escriba algo que no va a salir.
export const VENTANA_WHATSAPP_MS = 24 * 60 * 60 * 1000;

export const AVISO_VENTANA_CERRADA =
  'Han pasado más de 24 horas desde el último mensaje del cliente. '
  + 'WhatsApp solo permite responder con una plantilla.';

// `chat.lastIncomingMessageTime` viene del listado; `entrantesCargados` son las
// marcas de los mensajes del cliente ya pintados, que pueden ser más nuevos
// (llegan por WebSocket o por el sondeo sin recargar el listado).
//
// `null` en el campo es «el cliente no ha escrito nunca»: cerrada. Si el campo
// no viene (`undefined`), el frontend no sabe y deja que decida el backend.
//
// Instante (ms) en que se cierra la ventana: `null` si no aplica (otro canal o
// campo ausente) y `-Infinity` si el cliente no ha escrito nunca.
export const cierreVentanaWhatsApp = (chat, entrantesCargados = []) => {
  if (chat?.platform !== 'whatsapp' || chat.lastIncomingMessageTime === undefined) {
    return null;
  }
  const ultimo = [chat.lastIncomingMessageTime, ...entrantesCargados]
    .map(parseBackendDate)
    .filter(Boolean)
    .reduce((max, fecha) => Math.max(max, fecha.getTime()), -Infinity);
  return ultimo + VENTANA_WHATSAPP_MS;
};

export const ventanaWhatsAppCerrada = (chat, entrantesCargados = [], ahora = Date.now()) => {
  const cierre = cierreVentanaWhatsApp(chat, entrantesCargados);
  return cierre !== null && ahora > cierre;
};
